module.exports = __webpack_public_path__ + "img/vaseline.3d9a0eb7.gif";